<div class="mt-5">
  <mat-card class="card-general">
    <mat-card-title>Archivos adicionales</mat-card-title>
    <mat-card-content>
      <form [formGroup]="additionalFilesForm">
        <div class="filetype-aditionalfiles-container">
          <div *ngFor="let item of fileAdditionalArray" class="w-100 h-100">
            <app-drag-and-drop fileTitle="{{item.label}}" [parentForm]="additionalFilesForm" [nameControl]="item.name" isGenericFileType="true" [text]="'Inserta tu archivo aquí'" [accept]="application/octet-stream" (onSelectFile)="fileSelected($event, item)" (onDeleteFile)="deleteFile(item)" [fileSelected]="item.fileInfo">

            </app-drag-and-drop>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
